import type { StatItem } from "../Types/StatItemType";
import { formatStatValue } from "../Helpers/formatStatValue";

/**
 * Renders a stat value as a toggle button. Used wherever a StatItem carries an
 * `onClick` — the value itself becomes the control, the same way `href` turns it
 * into a link, so the stat stays a single glanceable unit rather than growing a
 * second button beside it.
 */
export function StatValueButton_({ item }: { item: StatItem }) {
  const active = item.active === true;
  return (
    <button
      type="button"
      onClick={item.onClick}
      aria-pressed={active}
      className={`-mx-1 cursor-pointer rounded px-1 font-bold underline-offset-2 transition-colors hover:underline focus-visible:ring-2 focus-visible:ring-brand focus-visible:outline-none ${active ? "bg-brand-subtle underline" : ""}`}
    >
      {formatStatValue(item)}
    </button>
  );
}
